import { ReactElement } from 'react'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'

import Meta from '@/components/base/meta'
import PageBuilder from '@/components/layout/builder'
import Layout from '@/components/layout/layout'
import { mapPageStaticProps } from '@/utils/page-data'
import { getPromiseFromFetch } from '@/utils/request'

import { WPPageData } from '@/types'

export default function Home(pageProps: InferGetStaticPropsType<typeof getStaticProps>) {
  return <PageBuilder pageProps={pageProps} />
}

Home.getLayout = function getLayout(page: ReactElement, pageProps: WPPageData) {
  return (
    <Layout pageProps={pageProps}>
      <Meta pageProps={pageProps} />
      {page}
    </Layout>
  )
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const locale = context.locale || 'en'
  const defaultLocale = context.defaultLocale || 'en'
  const { data: pageProps } = await getPromiseFromFetch<WPPageData>({
    method: 'get',
    url: `/${locale !== defaultLocale ? locale : ''}`
  })

  return {
    props: {
      ...(await mapPageStaticProps(pageProps))
    }
  }
}
